import Vue from 'vue'
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)

const routes = [
  // 默认登陆
  {
    path: '/',
    redirect: '/courseManagement'
  },
  //登录
  {
    path: '/login',
    name: 'login',
    component: () => import( /* webpackChunkName:'login'*/ '@/pages/login/login'),
    meta: {
      title: ''
    }
  },
  // 课节
  {
    path: '/courseManagement',
    name: 'courseManagement',
    component: () => import( /* webpackChunkName:'courseManagement'*/ '@/pages/courseManagement/courseManagement'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 作业
  {
    path: '/studentWork',
    name: 'studentWork',
    component: () => import( /* webpackChunkName:'courseManstudentWorkagement'*/ '@/pages/studentWork/studentWork'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 学员
  {
    path: '/student',
    name: 'student',
    component: () => import( /* webpackChunkName:'student'*/ '@/pages/student/student'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 我的
  {
    path: '/personalCenter',
    name: 'personalCenter',
    component: () => import( /* webpackChunkName:'personalCenter'*/ '@/pages/personalCenter/personalCenter'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 快速创建班级
  {
    path: '/quickCreation',
    name: 'quickCreation',
    component: () => import( /* webpackChunkName:'quickCreation'*/ '@/pages/quickCreation/quickCreation'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 添加课节
  {
    path: '/addCourses',
    name: 'addCourses',
    component: () => import( /* webpackChunkName:'addCourses'*/ '@/pages/addCourses/addCourses'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 创建班级
  {
    path: '/establishClass',
    name: 'establishClass',
    component: () => import( /* webpackChunkName:'establishClass'*/ '@/pages/establishClass/establishClass'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 编辑学员
  {
    path: '/editStudent',
    name: 'editStudent',
    component: () => import( /* webpackChunkName:'editStudent'*/ '@/pages/editStudent/editStudent'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 搜索页面
  {
    path: '/allSearch',
    name: 'allSearch',
    component: () => import( /* webpackChunkName:'allSearch'*/ '@/pages/allSearch/allSearch'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 全部课节
  {
    path: '/allCourse',
    name: 'allCourse',
    component: () => import( /* webpackChunkName:'allCourse'*/ '@/pages/allCourse/allCourse'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 编辑教师
  {
    path: '/editTeacher',
    name: 'editTeacher',
    component: () => import( /* webpackChunkName:'editTeacher'*/ '@/pages/editTeacher/editTeacher'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 消息
  {
    path: '/pushMessage',
    name: 'pushMessage',
    component: () => import( /* webpackChunkName:'pushMessage'*/ '@/pages/pushMessage/pushMessage'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 邀请二维码
  {
    path: '/invitationCode',
    name: 'invitationCode',
    component: () => import( /* webpackChunkName:'invitationCode'*/ '@/pages/invitationCode/invitationCode'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 财务
  {
    path: '/financeMessages',
    name: 'financeMessages',
    component: () => import( /* webpackChunkName:'financeMessages'*/ '@/pages/financeMessages/financeMessages'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
  // 财务详情
  {
    path: '/financeDetails',
    name: 'financeDetails',
    component: () => import( /* webpackChunkName:'financeDetails'*/ '@/pages/financeDetails/financeDetails'),
    meta: {
      title: '',
      requireAuth: true
    }
  },
];
const router = new Router({
  routes
});
// 路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (localStorage.TOKEN) {
      next();
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next();
  }
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js